import { onMounted, onUnmounted, nextTick, watch } from 'vue'

export function useScrollReveal(route) {
  let observer

  function observeElements() {
    observer?.disconnect()
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.08, rootMargin: '0px 0px -48px 0px' }
    )

    document.querySelectorAll('[data-reveal]:not(.is-visible)').forEach((el) => {
      observer.observe(el)
    })
  }

  onMounted(() => {
    nextTick(observeElements)
  })

  if (route) {
    watch(
      () => route.path,
      () => nextTick(observeElements)
    )
  }

  onUnmounted(() => {
    observer?.disconnect()
  })

  return { refreshReveal: observeElements }
}
